// on scroll functions
$(window).on('scroll',function() {
  // sticky hearer js
  var siteHeader = $('.template-index .site-header'),
      annoucementBar = $('#shopify-section-static-announcement').height();
  if ($(window).scrollTop() < 50) {
    $(siteHeader).mouseover(function(){$(this).addClass('fixed')});
    $(siteHeader).mouseout(function(){$(this).removeClass('fixed')});
  }else{
    $(siteHeader).mouseover(function(){$(this).addClass('fixed')});
    $(siteHeader).mouseout(function(){$(this).addClass('fixed')});
  }
  var scroll = $(window).scrollTop();
  if (scroll >= 50) {
    siteHeader.addClass('fixed');
    $(siteHeader).css('top','0');
  }else {
    siteHeader.removeClass('fixed');
    $(siteHeader).css('top',annoucementBar+'px');
  }
});

$(document).ready(function(){
  
  // sticky filter bar collection page
  var PLPheaderHeight = $('.site-header').height();
  $('.productgrid--sidebar').css('top',PLPheaderHeight);

  $(document).on('click', '#pdp-rightarrow', function(){
    $('.cust-paymenticon-toggle').slideToggle(200);
  });

   // wishlist btn append on PDP
   var interverCount = 0;
   var appendedSvg = $('svg#appended');
   var appnedWishBtn = setInterval(function(){
   var svgIcon = '<svg id="appended" width="22" height="22" xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M1270 4903 c-230 -16 -454 -95 -645 -228 -100 -70 -270 -244 -343 -352 -295 -435 -362 -1002 -176 -1501 79 -213 172 -356 373 -569 82 -87 571 -579 1088 -1094 690 -689 945 -938 966 -941 15 -3 39 -3 55 0 20 3 304 281 1080 1056 580 578 1080 1085 1111 1126 79 103 133 190 185 301 244 516 195 1148 -126 1622 -73 108 -243 282 -343 352 -95 66 -242 140 -339 171 -424 134 -809 36 -1211 -308 -116 -100 -232 -218 -323 -330 -30 -38 -58 -68 -62 -68 -4 0 -32 30 -62 68 -141 173 -355 372 -513 477 -238 157 -491 234 -715 218z m238 -233 c296 -71 623 -325 904 -702 61 -83 87 -109 114 -118 63 -21 93 -2 182 118 283 380 608 631 910 703 112 27 295 22 417 -11 547 -148 917 -737 864 -1377 -22 -271 -117 -525 -275 -736 -44 -58 -387 -405 -1061 -1074 -547 -543 -999 -989 -1003 -991 -10 -4 -1649 1626 -1885 1874 -95 100 -195 214 -222 255 -302 447 -317 1063 -38 1524 175 289 435 480 735 540 102 20 261 18 358 -5z"></path></g></svg>'
   $(`#wishlisthero-product-page-button-container`).appendTo(`[action="/cart/add"] .product-form--atc`);
   $(`#wishlisthero-product-page-button-container button`).html(svgIcon);
   if($('svg#appended').length > 0){
     clearInterval(appnedWishBtn);
   }
  },50);
  
  // equal height
  function equalHeight ($target) {
    var highestBox = 0;
    $($target).each(function(){        
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }   
    });
    $($target).height(highestBox);
  }

  // 5sec interval
  // var x = 0;
  // var interval = setInterval(function () {
  //   // equalHeight('.productitem .productitem--image');
  //   equalHeight('.productgrid--items .productitem--title');
  //  if (++x === 10) {
  //       window.clearInterval(intervalID);
  //     }
  // }, 500);


  $(document).on('click','.acco-title',function(){
    $(this).toggleClass('active').siblings('.indent-content').slideToggle(250);
  });


  // close filter bar  
  $(document).on('click','#closeFilterBar',function(){
    $(this).parent('.filter-open').removeClass('filter-open').addClass('filter-close');
  });

  // announcement-bar js
  $('.announcement-bar').slick({
    autoplay : true,
    autoplaySpeed : 3000, 
    speed: 800,
    slidesToShow : 1,
    arrows : false,
    dots : false,
    vertical: true,
    verticalScrolling: true,
    pauseOnHover: true
  });
  

  
  // pdp modal slider
  
  $('.data-modal-gallary').slick({  
    slidesToShow : 1,
    slideToScroll: 1,
    arrows : true,
    infinite: true, 
    dots:true
   });
  
  
 
  // pdp modal
  $('.product-gallery--media.product-gallery--image').on('click',function(){
    var index = $(this).attr('data-index-count') - 1;
    $('#pdpModal').addClass('open');
    $('body').css('overflow','hidden');
    console.log(index);
    $( '.data-modal-gallary' ).slick( 'slickGoTo', index);
  });

  $('#pdpModal #close').on('click',function(){
    $('#pdpModal').removeClass('open');
    $('body').css('overflow','auto');
  });
  
   // trigger scroll function in ready
   $(window).trigger('scroll');

   // header stiky position
   var annoucementBar = $('#shopify-section-static-announcement').height();
   $('.template-index .site-header').css('top',annoucementBar+'px');

  
  $(document).on('click','.productgrid--sidebar-title--small',function(){
    $(this).toggleClass('active');
    $(this).siblings().slideToggle(300);
  });
  

  // scroll bottom
  $(`a[href="#scrollBottom"]`).click(function(e){
    e.preventDefault();
    var bannerHeight = $('.story-banner-section').height() + 170;
    $("html, body").animate({ 
      scrollTop: `${bannerHeight}`
    },600)
  });
  
  
  //   theme.liquid's js
  // var stickyTop = $('.productgrid_filter').offset().top; 
  $(window).on( 'scroll', function(){
    
    var scroll_height = $(window).scrollTop();
    if (scroll_height >= 120) {
      jQuery('.productgrid_filter').addClass('productgrid-filter-fixed');
      $('.layout--has-sidebar .productgrid--wrapper').addClass('productgrid-wrapper-active');
    }else{
      $('.productgrid_filter').removeClass('productgrid-filter-fixed');
      $('.layout--has-sidebar .productgrid--wrapper').removeClass('productgrid-wrapper-active');
    }
    
  });
  
  $(document).on("click",".custom_filter-title",function() {
    var block_id = $(this).attr("data-href");
    
    $(".custom_filter_title_tab").removeClass("filter-tab-active");
    $(this).parent("div.custom_filter_title_tab").addClass("filter-tab-active");
    $(".custome_filter-content-wraper, .custom_filter_content").addClass("filter-close").removeClass("filter-open");
    $(".custome_filter-content-wraper, .custom_"+block_id).addClass("filter-open").removeClass("filter-close");
  }); 
  
  $(document).on("click",".pro_viewtoggle_button_3",function() {
    $(".pro_viewtoggle_button").removeClass("viewtoggle_button_active");
    $(this).addClass("viewtoggle_button_active");
    $("#productgrid_items_view").removeClass("productgrid_items_view_4 productgrid_items_view_6");
    $("#productgrid_items_view").addClass("productgrid_items_view_3");
  });
  $(document).on("click",".pro_viewtoggle_button_4",function() {
    $(".pro_viewtoggle_button").removeClass("viewtoggle_button_active");
    $(this).addClass("viewtoggle_button_active");
    $("#productgrid_items_view").removeClass("productgrid_items_view_3 productgrid_items_view_6");
    $("#productgrid_items_view").addClass("productgrid_items_view_4");
  });
  $(document).on("click",".pro_viewtoggle_button_6",function() {
    $(".pro_viewtoggle_button").removeClass("viewtoggle_button_active");
    $(this).addClass("viewtoggle_button_active");
    $("#productgrid_items_view").removeClass("productgrid_items_view_4 productgrid_items_view_3");
    $("#productgrid_items_view").addClass("productgrid_items_view_6");
  });
  
  $('.tablinks').click(function(e){
    e.stopPropagation();
    e.preventDefault();
    var link = $(this).attr('href');
    // console.log(link);
    $(location).attr('href', link); 
  });
  
  jQuery(".afterpay-text1").text("4 payments of ");
  jQuery(".afterpay-text2").text(" with ");
  jQuery(".afterpay-link").html('<img class="afterpay-logo-moreLink" src="https://cdn.shopify.com/s/files/1/0033/5950/6547/files/afterpey-gray.png?v=1622604776" srcset="https://cdn.shopify.com/s/files/1/0033/5950/6547/files/afterpey-gray.png?v=1622604776" width="100" height="21" alt="Afterpay" style="vertical-align: middle; width: 100px; border: 0px;">');
  jQuery(".afterpay-logo").css("display","none");
  
  $(window).on('load','afterpay-link', function(){
    $(this).remove();
  });  
  

  $(document).on('click','#sizeOutofStock',function(){
    $('#klaviyo-bis-iframe').css('display','block');
  });
  


});

// start product page sizechart js
$(document).ready(function(){  
    $('#sizeChartTrigger,.site-header-size-icon').click(function(){
      $('#chartPopupWrapper').addClass('open');
      $('body').css('overflow-y','hidden');
    });

    $('#closeSizeChart').click(function(){
      $('#chartPopupWrapper').removeClass('open');
      $('body').css('overflow-y','auto');
    });  
});
// end product page sizechart js
// start product page sizechart popup js
function openTab(evtMain, TabNameMain) {
    var iMain, tabcontentMain, tablinksMain;
    tabcontentMain = document.getElementsByClassName("tabcontent");
    for (iMain = 0; iMain < tabcontentMain.length; iMain++) {
      tabcontentMain[iMain].style.display = "none";
    }
    tablinksMain = document.getElementsByClassName("tablinks");
    for (iMain = 0; iMain < tablinksMain.length; iMain++) {
      tablinksMain[iMain].className = tablinksMain[iMain].className.replace(" active", "");
    }
    document.getElementById(TabNameMain).style.display = "block";
    evtMain.currentTarget.className += " active";
  }
  function opensubTab(evtSub, TabNameSub) {
    var iSub, tabcontentSub, tablinksSub;
    tabcontentSub = document.getElementsByClassName("tabcontentsub");
    for (iSub = 0; iSub < tabcontentSub.length; iSub++) {
      tabcontentSub[iSub].style.display = "none";
    }
    tablinksSub = document.getElementsByClassName("tablinkssub");
    for (iSub = 0; iSub < tablinksSub.length; iSub++) {
      tablinksSub[iSub].className = tablinksSub[iSub].className.replace(" active", "");
    }
    document.getElementById(TabNameSub).style.display = "block";
    evtSub.currentTarget.className += " active";
  }
  function opensubParentTab(evtPerentSub, TabNamePerentSub) {
    var iPerentSub, tabcontentPerentSub, tablinksPerentSub;
    tabcontentPerentSub = document.getElementsByClassName("tabcontentsubperent");
    for (iPerentSub = 0; iPerentSub < tabcontentPerentSub.length; iPerentSub++) {
      tabcontentPerentSub[iPerentSub].style.display = "none";
    }
    tablinksPerentSub = document.getElementsByClassName("tablinksperent");
    for (iPerentSub = 0; iPerentSub < tablinksPerentSub.length; iPerentSub++) {
      tablinksPerentSub[iPerentSub].className = tablinksPerentSub[iPerentSub].className.replace(" active", "");
    }
    document.getElementById(TabNamePerentSub).style.display = "block";
    evtPerentSub.currentTarget.className += " active";
  }
 

// end product page sizechart popup js